<template>
  <div id="calculator">
    <div style="text-align: center;font-size: 20px;font-weight: bold;padding-top: 20px">
      计算器
    </div>
    <div class="display">
      <input type="text" style="width: 90%;height: 30px;text-align: right;font-size: 20px" v-model="result" readonly placeholder="结果" />
    </div>
    <div class="buttons">
      <div class="row">
        <button @click="calculate('7')">7</button>
        <button @click="calculate('8')">8</button>
        <button @click="calculate('9')">9</button>
        <button class="operation" @click="calculate('/')">÷</button>
      </div>
      <div class="row">
        <button @click="calculate('4')">4</button>
        <button @click="calculate('5')">5</button>
        <button @click="calculate('6')">6</button>
        <button class="operation" @click="calculate('*')">×</button>
      </div>
      <div class="row">
        <button @click="calculate('1')">1</button>
        <button @click="calculate('2')">2</button>
        <button @click="calculate('3')">3</button>
        <button class="operation" @click="calculate('-')">-</button>
      </div>
      <div class="row">
        <button @click="calculate('0')">0</button>
        <button @click="calculate('.')">.</button>
        <button class="clear" @click="clear()">C</button>
        <button class="operation" @click="calculate('+')">+</button>
      </div>
      <div class="row">
        <button @click="equal()">=</button>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: 'computer',
  data() {
    return {
      result: ''
    };
  },
  methods: {
    calculate(char) {
      this.result += char;
    },
    clear() {
      this.result = '';
    },
    equal() {
      try {
        // 使用Javascript的eval函数来计算表达式的值
        this.result = eval(this.result);
      } catch (e) {
        this.result = 'Error';
      }
    },
  },
  watch: {
    display(val) {
      if (val.indexOf('.') !== -1) {
        this.decimal = true;
      } else {
        this.decimal = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#calculator {
  max-width: 90%;
  margin: 0px auto;
}

.display {
  width: 100%;
  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;
  font-size: 14px;
  text-align: center;
}

.buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

button {
  padding: 10px;
  border: none;
  background-color: #fff;
  color: #333;
  font-size: 50px;
  font-weight: bold;
  width: 160px;
  height: 120px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
}

button:hover {
  background-color: #f2f2f2;
}

.operation {
  background-color: #ff8c
}
</style>
